import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import blogApi, { fileUrl } from "../apiProvider/blog";

const BlogDetailsLayer = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    if (id) blogApi.get(id).then(setBlog);
  }, [id]);

  if (!blog) return <div className="card"><div className="card-body">Loading blog preview...</div></div>;

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <div>
          <h6 className="mb-0">Blog Preview</h6>
          <small className="text-secondary-light">Status: {blog.status}</small>
        </div>
        <Link className="btn btn-primary-600" to={`/blog-edit/${blog._id}`}>Edit</Link>
      </div>
      <div className="card-body p-32">
        {fileUrl(blog.coverImage) && (
          <img src={fileUrl(blog.coverImage)} alt="" className="w-100 max-h-400-px object-fit-cover radius-8 mb-24" />
        )}
        <h1 className="mb-12">{blog.title}</h1>
        <div className="d-flex flex-wrap gap-12 mb-24 text-secondary-light">
          <span>{blog.category?.name || "Uncategorized"}</span>
          <span>{blog.publishedAt ? new Date(blog.publishedAt).toLocaleDateString() : "Draft"}</span>
          {blog.focusKeyword && <span>Keyword: {blog.focusKeyword}</span>}
        </div>
        {blog.excerpt && <p className="lead">{blog.excerpt}</p>}
        <div className="blog-preview-content" dangerouslySetInnerHTML={{ __html: blog.contentHtml }} />
        <div className="mt-32 p-20 bg-neutral-50 radius-8">
          <h6>SEO Preview</h6>
          <p className="mb-1"><strong>Title:</strong> {blog.metaTitle || blog.title}</p>
          <p className="mb-1"><strong>Description:</strong> {blog.metaDescription || "-"}</p>
          <p className="mb-0"><strong>Canonical:</strong> {blog.canonicalUrl || `https://coloursboutique.com/blog/${blog.slug}`}</p>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsLayer;
